
export default {
    name: 'LeeSlideCheck',
    inheritAttrs: false,
    data() {
        return {
            moveX: 0,
            isOk: false,
            isDown: false,
            oldX: 0,
            ms: '0s'
        }
    },
    mounted() {
        document.addEventListener('mousedown', (e) => {
            this.oldX = e.pageX
            this.isDown = true
        })
        document.addEventListener('mousemove', (e) => {
            e.stopPropagation()
            if (this.isDown) {
                let target = this.$refs.handle
                this.moveX = e.pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }


        })
        document.addEventListener('mouseup', () => {
            this.isDown = false
        })
    },
    methods: {
        mouseDown(e) {
            this.oldX = e.pageX
            this.isDown = true
        },
        mouseMove(e) {
            if (this.isDown) {
                let target = e.currentTarget
                this.moveX = e.pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }
        },
        mouseUp() {
            this.isDown = false
        },
        touchStart(e) {
            this.oldX = e.targetTouches[0].pageX
            this.isDown = true
        },
        touchMove(e) {
            if (this.isDown) {
                let target = e.currentTarget
                this.moveX = e.targetTouches[0].pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }
        },
        touchEnd() {
            this.isDown = false
        },
    },
    props: {
        fontSize: {
            type: Number,
            default: 12
        },
        width: {
            type: Number,
            default: 300
        },
        height: {
            type: Number,
            default: 34
        },
        bgColor: {
            type: String,
            default: '#7ac23c'
        }
    },
    watch: {
        isDown: {
            immediate: false,
            handler(value) {
                if (!value && !this.isOk) {
                    this.moveX = 0
                    this.ms = '.2s'
                    this.$emit('end', 'no')
                } else {
                    this.ms = '0s'
                }
            }
        },
        isOk: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.$emit('end', 'ok')
                }
            }
        }
    },
};
